<template>
  <div class="video-player">
    <video
      ref="videoPlayer"
      class="video-js vjs-default-skin vjs-big-play-centered"
      controls
      preload="auto"
    ></video>
  </div>
</template>

<script>
import { onMounted, onBeforeUnmount, ref, watch } from "vue"
import videojs from "video.js";
import "video.js/dist/video-js.css";

export default {
  name: "VideoPlayer",
  props: {
    videoSrc: {
      type: String,
      required: true
    },
    poster: {
      type: String,
      default: ""
    },
    isLoop: {
      type: Boolean,
      default: false
    },
    playbackRate: {
      type: Number,
      default: 1.0
    }
  },
  setup(props) {
    const videoPlayer = ref(null);
    let player = null;

    onMounted(() => {
      player = videojs(videoPlayer.value, {
        controls: true,
        autoplay: false,
        preload: "auto",
        fluid: true,
        poster: props.poster,
        loop: props.isLoop,
        playbackRates: [0.7, 1, 1.2],
        sources: [
          {
            src: props.videoSrc,
            type: "video/mp4"
          }
        ]
      })

      // 设置初始播放速度
      player.playbackRate(props.playbackRate)
    })
    watch(
      () => props.videoSrc,
      (newSrc) => {
        if (player) {
          player.src({ src: newSrc, type: "video/mp4" })
          player.load()
          player.play()
        }
      }
    )

    watch(
      () => props.playbackRate,
      (newRate) => {
        if (player) {
          player.playbackRate(newRate);
        }
      }
    );
    watch(
      () => props.isLoop,
      (newVal) => {
        if (player) {
          player.loop(newVal)
        }
      }
    );
    onBeforeUnmount(() => {
      if (player) {
        player.dispose()
      }
    })

    return {
      videoPlayer
    };
  },
};
</script>

<style>
.video-player {
  margin: 0 auto;
  max-width: 100%;
  position: relative;
}

/* 确保播放器在容器内居中 */
.video-js {
  width: 100% !important;
  height: auto !important;
}
</style>
